'use client'

import { useRef, useState } from "react"
import styles from './ua.module.scss'
import Button from "../button/Button"
import Dropdown from "../dropdown/Dropdown"
import Form from "../form/Form"
import Icon from "../icon/Icon"
import StackedPanel from "../panel/StackedPanel"
import PanelBody from "../panel/PanelBody"
import PanelFooter from "../panel/PanelFooter"
import { useRouter } from "next/navigation"
import { genInvUrl, getFiltersFromParams } from "@/data/Inventory"


export default function FuelButton(props) {
    const fuelTypes = ['Gasoline', 'Diesel', 'Electric', 'Hybrid']
    const [selected, setSelected] = useState(props.filters.fuel || [])
    const ddFuelTypes = useRef()
    const router = useRouter()

    const toggle = (e) => {
        if (e) e.preventDefault()
        ddFuelTypes.current.toggle()
    }

    const isSelected = (fuel) => {
        return selected.indexOf(fuel) >= 0
    }

    const clear = (e) => {
        setSelected([])
        props.listingRef.current.applyFilters({ fuel: [], clear: true })
        toggle(e)
    }

    const onItemToggle = (e, item) => {
        const list = [...selected]
        const fuelIndex = list.indexOf(item)
        if (fuelIndex >= 0) {
          list.splice(fuelIndex, 1)
        } else {
          list.push(item)
        }
        setSelected(list)
    }

    const onSubmit = (e) => {
        toggle(e)
        let urlParams = Object.assign(getFiltersFromParams(props), props.filters || {})
        urlParams.fuel = selected.join(",")
        const url = genInvUrl(urlParams, {})
        router.push(url)
    }

    return (
        <>
            <Button theme={["filter-icon", "filter-icon-wide", (selected.length > 0 ? 'filter-on' : '')]} onClick={e => toggle(e) } label={"Filter by Fuel"}>
                <Icon {...props} name="fuel-type"></Icon>
                <span>{ 'Fuel' }</span>
            </Button>
            <Dropdown {...props} key="fuelTypes" ref={ddFuelTypes} position={'right'} body={'padded'} offset={'12px'} title="Filter by Fuel">
                <Form id="fuel_picker" name="Fuel Picker" onSubmit={e => onSubmit(e)}>
                    <StackedPanel>
                        <PanelBody padded={true}>
                            <div className={styles.cls}>
                                { fuelTypes.map(fuel => (
                                    <div key={fuel} className={styles.bri}>
                                        <Button theme={["gray-light-hover", isSelected(fuel) ? "filter-on" : "transparent", "filter-opt", "inline"]} label={fuel} onClick={e => onItemToggle(e, fuel)}></Button>
                                    </div>
                                ))}
                            </div>
                        </PanelBody>
                        <PanelFooter>
                            <div className="flex-row flex-with-gap flex-full">
                            <div className="flex-col flex-stretch flex-col50">
                                <Button theme={'secondary'} label="Apply Filters"></Button>
                            </div>
                            <div className="flex-col flex-stretch flex-col50">
                                <Button theme={'gray-light'} disabled={selected.length == 0} label="Clear" onClick={e => clear()}></Button>
                            </div>
                            </div>
                        </PanelFooter>
                    </StackedPanel>
                </Form>
            </Dropdown>
        </>
    )
}